// Shared by the Fumigación Aérea form and its historial.
export const APPLICATION_TYPES = [['emulsion', 'Emulsión'], ['agua', 'Agua']];

// Doses keep up to 4 decimals (e.g. HRYZUP 0,0099); volumes always show 2.
export const fmtDose = (v) => Number(v).toLocaleString('es-EC', { maximumFractionDigits: 4 });
export const fmtVolume = (v) => Number(v).toLocaleString('es-EC', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// A dose is of a liquid (in a volume unit) or a powder (in a weight unit), as in the API.
export const DOSE_FORMS = [['liquido', 'Líquido'], ['polvo', 'Polvo']];
export const DOSE_UNITS = {
  liquido: [['gal', 'Galones'], ['l', 'Litros'], ['ml', 'Mililitros'], ['cc', 'Centímetros cúbicos'], ['floz', 'Onzas líquidas']],
  polvo: [['kg', 'Kilogramos'], ['g', 'Gramos'], ['lb', 'Libras'], ['oz', 'Onzas'], ['qq', 'Quintales']],
};
const UNIT_SHORT = {
  gal: 'gal', l: 'L', ml: 'ml', cc: 'cc', floz: 'fl oz', kg: 'kg', g: 'g', lb: 'lb', oz: 'oz', qq: 'qq',
};

// "0,85 L" (lines saved before units existed show just the number).
export const fmtDoseUnit = (line) => `${fmtDose(line.dose)}${line.unit ? ` ${UNIT_SHORT[line.unit]}` : ''}`;

// "Mensaje" export of Historial de Fumigación: one fumigation as the text sent by WhatsApp, e.g.
//   Fumigacion Ipanema ciclo # 31 / Area 71Ha / Fecha 22/09/2026 / Metadel 2,03 kgs/ha / … /
//   Solo en Agua / Volumen 7 gls / Capitan: Fernando Jacho
const UNIT_PER_HA = {
  gal: 'gls', l: 'lts', ml: 'ml', cc: 'cc', floz: 'fl oz', kg: 'kgs', g: 'g', lb: 'lbs', oz: 'oz', qq: 'qq',
};
export function fumigationMessage(row) {
  const [y, m, d] = row.date.split('-');
  const lines = [`Fumigacion ${row.farm_name} ciclo # ${row.cycle}`];
  if (row.fumigated_hectares != null) lines.push(`Area ${fmtDose(row.fumigated_hectares)}Ha`);
  lines.push(`Fecha ${d}/${m}/${y}`);
  row.products.forEach((p) => {
    lines.push(`${p.product_name} ${fmtDose(p.dose)}${p.unit ? ` ${UNIT_PER_HA[p.unit]}/ha` : ''}`);
  });
  lines.push(row.application_type === 'agua' ? 'Solo en Agua' : 'Emulsión');
  lines.push(`Volumen ${fmtDose(row.volume)} gls`);
  lines.push(`Capitan: ${row.pilot_name}`);
  if (row.observations) lines.push(`Obs: ${row.observations}`);
  return lines.join('\n');
}
